export const recordStatus = {
  ACTIVE: 0,
  DELETE: 1,
  ARCHIVE: 2,
  BLOCKED: 3,
  REMOVED: 3,
  NEW: 4
};
